/**
 * @generated SignedSource<<2231c896924fc4d166f219ff140d25a7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_softwareCodePage_MainPage$data = {
  readonly " $fragmentSpreads": FragmentRefs<"main_softwareCodePage_PullRequests" | "main_softwareCodePage_Repositories">;
  readonly " $fragmentType": "main_softwareCodePage_MainPage";
};
export type main_softwareCodePage_MainPage$key = {
  readonly " $data"?: main_softwareCodePage_MainPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_softwareCodePage_MainPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "numPullRequestsToFetch"
    },
    {
      "kind": "RootArgument",
      "name": "projectKey"
    },
    {
      "kind": "RootArgument",
      "name": "pullRequestsUpdatedFrom"
    }
  ],
  "kind": "Fragment",
  "name": "main_softwareCodePage_MainPage",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "main_softwareCodePage_Repositories"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        },
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "numPullRequestsToFetch"
        },
        {
          "kind": "Variable",
          "name": "projectKey",
          "variableName": "projectKey"
        },
        {
          "kind": "Variable",
          "name": "updatedFrom",
          "variableName": "pullRequestsUpdatedFrom"
        }
      ],
      "kind": "FragmentSpread",
      "name": "main_softwareCodePage_PullRequests"
    }
  ],
  "type": "Query"
};

(node as any).hash = "7a99c6a5afd68e6064d6b069fe3b0b21";

export default node;
